'use strict';

const events = require('dom-events');

const msg = require('../messages.js');
const utils = require('../utils.js');

const ConsentKeeperMixin = require('../mixins/consent-keeper.js');
const ValidationMixin = require('../mixins/validation.js');

function Form (ref) {
  this.cls = {
    invisible: 'invisible',
    hidden: 'hidden',
    notificationSuccess: 'notification--success',
    notificationError: 'notification--error',
    inputSubmitDisabled: 'input-submit--disabled'
  };

  this.refs = {
    root: '',
    form: '[data-ref="form-' + ref + '"]',
    formNotification: '[data-ref="notification-form-' + ref + '"]',
    submit: '[data-ref="submit-' + ref + '"]'
  };
}

ConsentKeeperMixin.call(Form.prototype);
ValidationMixin.call(Form.prototype);

Form.prototype.showFormNotification = function (message, error) {
  var error = error || false;

  var formNotification = document.querySelector(this.refs.formNotification);
  formNotification.className = formNotification.className
    .replace(' ' + this.cls.hidden, '');
  formNotification.className = formNotification.className
    .replace(' ' + this.cls.notificationSuccess, '');
  formNotification.className = formNotification.className
    .replace(' ' + this.cls.notificationError, '');

  var cls = this.cls.notificationSuccess;
  if (error) {
    cls = this.cls.notificationError;
  }
  formNotification.className = formNotification.className.concat(' ' + cls);

  var notificationText = formNotification.firstElementChild;
  notificationText.textContent = message;
};

Form.prototype.hideFormNotification = function () {
  var formNotification = document.querySelector(this.refs.formNotification);
  if (!formNotification.className.includes(this.cls.hidden)) {
    formNotification.className = formNotification.className
      .concat(' ' + this.cls.hidden);
  }
};

Form.prototype.enableSubmit = function (value) {
  var submit = document.querySelector(this.refs.submit);
  submit.className = submit.className
    .replace(' ' + this.cls.inputSubmitDisabled, '');
  submit.value = value;
  submit.disabled = false;
};

Form.prototype.disableSubmit = function (value) {
  var submit = document.querySelector(this.refs.submit);
  if (!submit.className.includes(this.cls.inputSubmitDisabled)) {
    submit.className = submit.className
      .concat(' ' + this.cls.inputSubmitDisabled);
  }
  submit.value = value;
  submit.disabled = true;
};

Form.prototype.updatePosition = function (dest) {
  var form = document.querySelector(this.refs.form);
  form = form.parentNode.removeChild(form);
  dest.appendChild(form);
};

Form.prototype.resetPosition = function () {
  var root = document.querySelector(this.refs.root);
  this.updatePosition(root);
};

Form.prototype.scrollToVisible = function () {
  var form = document.querySelector(this.refs.form);
  window.scrollTo(0, form.offsetTop - 50);
};

Form.prototype.gainFocus = function () {};

Form.prototype.clearFields = function () {
  throw 'Method not implemented';
};

Form.prototype.successConsent = function (response) {
  throw 'Method not implemented';
};

Form.prototype.errorConsent = function (error) {
  throw 'Method not implemented';
};

Form.prototype.onChange = function (event) {
  event.preventDefault();
  throw 'Method not implemented';
};

Form.prototype.onSubmit = function (event) {
  var form = utils.findTarget(this.refs.form, event);
  if (form) {
    event.preventDefault();
    throw 'Method not implemented';
  }
};

Form.prototype.onBindEvents = function (event) {
  var form = utils.findTarget(this.refs.form, event);
  if (form) {
    form.className = form.className.replace(' ' + this.cls.invisible, '');
  }
};

Form.prototype.bindEvents = function () {
  this.onChange = this.onChange.bind(this);
  events.on(document, 'change', this.onChange);

  this.onSubmit = this.onSubmit.bind(this);
  events.on(document, 'submit', this.onSubmit);

  var form = document.querySelector(this.refs.form);
  this.onBindEvents = this.onBindEvents.bind(this);
  events.on(form, 'bindEvents', this.onBindEvents);
  events.emit(form, 'bindEvents');
};

module.exports = Form;



//////////////////
// WEBPACK FOOTER
// ./_js/forms/form.js
// module id = 10
// module chunks = 0 1 2